import { ClickBustingConfig } from './ClickBusting';

export interface SharedWidgetsConfig {
  /**
   * VizClient uses a technique called "click busting" (see ClickBuster.cs) to improve perceived responsiveness
   * of taps on iOS. This has some fundamental incompatibilities with React's reimplemented event system. Setting
   * this class name will allow incompatible Widgets to mark themselves as such.
   */
  suppressClickBustingClassName?: string;
}

const setClickBusting = (config: SharedWidgetsConfig): void => {
  if (!config.suppressClickBustingClassName) { return; }

  ClickBustingConfig.suppressionClassName = config.suppressClickBustingClassName;
};

export const setConfig = (config: SharedWidgetsConfig): void => {
  setClickBusting(config);
};
